import type { BiomeId } from './types';

export type MemorialCause = 'old-age' | 'expedition' | 'neglect';

export interface Memorial {
  id: string;
  npcId: string;
  npcName: string;
  cause: MemorialCause;
  diedAtMs: number;
  biome: BiomeId;
  x: number;
  y: number;
}

export interface CreateMemorialInput {
  npcId: string;
  npcName: string;
  cause: MemorialCause;
  diedAtMs: number;
  biome: BiomeId;
  x: number;
  y: number;
}

export function createMemorial(input: CreateMemorialInput): Memorial {
  return {
    id: `memorial-${input.npcId}`,
    ...input,
  };
}
